import { collection, addDoc, query, where, orderBy, getDocs, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { getAllAccounts } from './Account';

export const updatePlaytime = async (id, playtime) => {
  return await updateDoc(doc(db, 'playtime', id), playtime);
};

export const removePlaytime = async (playtime) => {
  return await deleteDoc(doc(db, 'playtime', playtime.id));
};

export const setPlaytime = async (registerObj) => {
  return await addDoc(collection(db, 'playtime'), registerObj);
};

export const getPlaytime = async (uid) => {
  const querySnapshot = await getDocs(
    query(collection(db, 'playtime'), where('user', '==', uid), orderBy('date', 'desc'))
  );

  const playtime = [];
  querySnapshot.forEach((doc) => {
    playtime.push({ ...doc.data(), id: doc.ref.id });
  });

  return playtime;
};

export const getAllPlaytime = async (from, to) => {
  const querySnapshot = await getDocs(
    query(
      collection(db, 'playtime'),
      where('registered', '>=', from),
      where('registered', '<=', to),
      orderBy('registered', 'desc')
    )
  );

  const playtime = [];
  let users = [];
  querySnapshot.forEach((doc) => {
    playtime.push(doc.data());
  });

  await getAllAccounts().then((response) => {
    users = response;
  });

  return playtime.map((time) => {
    let { user, ...rest} = time;
    
    return {
      ...rest,
      ...users.find(user => user.uid === time.user)
    };
  });
};
